import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { BannerPositionsDataService, BannerPositionsColumnsService } from '../../../services';
import { BannerPosition, BannerPositionsResult } from '../../../interfaces';

@Component({
  selector: 'app-banner-position-form',
  templateUrl: './banner-position-form.component.html',
  styleUrls: ['./banner-position-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerPositionFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public bannerPosition: BannerPosition = {};
  public bannerPositionForm: FormGroup = new FormGroup({});
  public bannerPositions: BannerPosition[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannerPositionsDataService: BannerPositionsDataService,
    public bannerPositionsColumnsService: BannerPositionsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'BannerPositionFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner Position - Edit');
        this.getBannerPosition(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerPosition !== 'undefined') {
      this.bannerPosition = this.dynamicDialogConfig.data.bannerPosition;
    }
    if (typeof this.bannerPosition.id === 'undefined' || this.bannerPosition.id === null) {
      this.bannerPosition.id = null;
      this.bannerPosition.isFullScreen = false;
      this.bannerPosition.displayOneTime = false;
      this.bannerPosition.isPublished = false;
    }
    this.getBannerPositions();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'BannerPositionFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'BannerPositionFormComponent');
  }

  getBannerPosition(id: number): void {
    this.isLoading = true;
    this.bannerPositionsDataService.getBannerPosition(id).subscribe((response: BannerPosition|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerPosition = response;
        this.prepareFrom();
      }
    });
  }

  getBannerPositions(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerPositions !== 'undefined' && this.dynamicDialogConfig.data.bannerPositions.length > 0) {
      this.bannerPositions = this.dynamicDialogConfig.data.bannerPositions;
      return;
    }
    this.bannerPositionsDataService.getBannerPositions(this.parameters).subscribe((response: BannerPositionsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerPositions = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.bannerPositionForm = new FormGroup({
      id: new FormControl(this.bannerPosition.id, []),
      name: new FormControl(this.bannerPosition.name, [Validators.required, ]),
      slug: new FormControl(this.bannerPosition.slug, [Validators.required, ]),
      itemsNumber: new FormControl(this.bannerPosition.itemsNumber, [Validators.required, ]),
      displayTime: new FormControl(this.bannerPosition.displayTime, [Validators.required, ]),
      isFullScreen: new FormControl(this.bannerPosition.isFullScreen, [Validators.required, ]),
      displayOneTime: new FormControl(this.bannerPosition.displayOneTime, [Validators.required, ]),
      isPublished: new FormControl(this.bannerPosition.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/banner-positions']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.bannerPositionForm.controls).forEach((field: any) => {
        const control = this.bannerPositionForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.bannerPositionForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.bannerPosition = this.bannerPositionForm.value;
    this.disableSubmit = true;
    console.log('bannerPosition', this.bannerPosition);
    if (typeof this.bannerPosition.id !== 'undefined' && this.bannerPosition.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.bannerPositionsDataService.updateBannerPosition(this.bannerPosition).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERPOSITIONUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERPOSITIONNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.bannerPositionsDataService.addBannerPosition(this.bannerPosition).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERPOSITIONCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERPOSITIONNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-banner-position-form',
  templateUrl: './banner-position-form.component.html',
  styleUrls: ['./banner-position-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerPositionFormComponent extends BannerPositionFormComponent {
}

